export default function MuteIcon(props: { fill?: string }) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" role="img">
        <path
          style={{
            fill: props?.fill ?? 'white',
            stroke: 'none',
            fillRule: 'nonzero',
            fillOpacity: 1
          }}
          d="M19.672 1.652a1.086 1.086 0 0 0-1.535.02L3.324 16.809a1.087 1.087 0 1 0 1.555 1.52L19.69 3.19a1.09 1.09 0 0 0-.02-1.539ZM17.023 7.781a4.72 4.72 0 0 1-4.145 6.938v2.418c3.927-.012 7.118-3.207 7.118-7.137 0-1.48-.453-2.855-1.23-4ZM12.879 2.863v2.313l1.98-2.028a7.2 7.2 0 0 0-1.98-.285Zm0 0"
        ></path>
        <path
          style={{
            fill: props?.fill ?? 'white',
            stroke: 'none',
            fillRule: 'nonzero',
            fillOpacity: 1
          }}
          d="M12.879 13.832A3.84 3.84 0 0 0 16.69 10c0-.55-.117-1.07-.324-1.543L12.88 12.02ZM9.59 18.129c.36.281.848.336 1.258.137.41-.2.672-.618.672-1.075v-3.785l-3.45 3.528ZM11.52 6.563V2.808c0-.457-.262-.875-.672-1.075-.41-.199-.899-.144-1.258.137l-4.504 3.55H1.28C.574 5.422 0 5.997 0 6.704v6.594c0 .707.574 1.281 1.281 1.281H3.68Zm0 0"
        ></path>
      </svg>
    </>
  )
}
